<template>
  <div class="img-wrapper" :style="{'flex-direction':direction}">
    <fragment :key="index" v-for="(item,index) in imgList">
      <div class="img-item" v-if="index <= imgListType" @click="handleImgClick(item, index)">
        <img :src="item.url" alt="" />
      </div>
    </fragment>
  </div>
</template>

<script>
import { getQueryString } from "@/utils/utils";
export default {
  name: "Cimage",
  props: {
    info: {
      type: Object,
      required: true
    },
    direction: {
      type: String,
      default: "row"
    },
    activityId: {
      type: String,
      required: true
    },
    activityStatus: {
      type: Number,
      required: true
    },
    activityType: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      imgList: [], // 图片列表
      imgListType: '', // 图片列表类型
    };
  },
  computed: {
    enterSource() {
      return this.getEnterSource();
    },
  },
  inject: ['getEnterSource'],
  mounted() {
    this.formatData()
  },
  methods: {
    formatData() {
      this.imgList = this.info.baseConfig.imgList
      this.imgListType = this.info.baseConfig.imgListType
    },
    async handleImgClick(item, index) {
      // try {
      //   TDAPP.onEvent(`图片${this.info.name}`, `图${index + 1}`)
      // } catch (e) {
      //   console.log('打点失败', e)
      // }

      let attendModel = '';

      // 此处判断，当配置为8时，调用领券接口
      if (item.clickForwardConfig && item.clickForwardConfig.jumpType == 8) {
        const res = await this.attendCoupon(item.clickForwardConfig);

        if (res && res.success) {
          this.showToast('领取成功')
        } else {
          this.showToast(res && res.errorMessage || '领取失败')
        }

        if (res && res.model && res.model.length) {
          attendModel = JSON.stringify(res.model);
        }
      }

      this.defer(
        () => {
          this.$log.senLog({
            pointID: '12010002',
            eventType: 2,
            businessData: {
              activityType: this.activityType !== undefined ? this.activityType : '',
              activityId: this.activityId || '',
              url: item.url || '',
              enterSource: this.enterSource || '',
              attendModel: attendModel || '',
            }
          })
        },
        () => { this.$emit("handleImgClick", item) }
      )
    },

    // 领券接口（jumpType == 8）
    async attendCoupon(clickForwardConfig) {
      const openId = getQueryString("openId");
      const params = {
        clickForwardConfig,
        openId: openId,
      }
      try {
        const res = await this.$fetch(
          { url: '/ehs/activity/attend', method: 'post' },
          params
        )
        return res
      } catch (e) {
        return e
      }
    },
    // 轻提示
    showToast(txt) {
      this.$toast({
        styles: {
          maskColor: "rgba(0,0,0,0)",
          background: "rgba(0,0,0,0.4)",
          messageColor: "#fff"
        },
        content: txt,
        duration: 3000
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.img-wrapper {
  display: flex;

  .img-item {
    flex: 1;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>